// src/helpers/settingsHelper.ts
import notify from 'devextreme/ui/notify';
import { DataGridRef } from 'devextreme-react/data-grid';
import { ISettingRequestParams } from '../types/crm-contact';
import { ColumnSetting } from './columnSetting';
import { SavedSetting } from '../components/library/page-setting/SettingsPopup';

// Stub functions - TODO: Implement with Supabase
const pageSettingsGetListRequest = async (settingPage: string, settingObject: string): Promise<{ resCode: number; resMessage: string; dataSet: any[] }> => ({ resCode: 400, resMessage: 'Not implemented', dataSet: [] });
const pageSettingsGetDefaultListRequest = async (settingPage: string, settingObject: string): Promise<{ resCode: number; resMessage: string; dataSet: any[] }> => ({ resCode: 400, resMessage: 'Not implemented', dataSet: [] });
const pageSettingsPostRequest = async (params: ISettingRequestParams): Promise<{ resCode: number; resMessage: string }> => ({ resCode: 400, resMessage: 'Not implemented' });

export const getCurrentGridColumns = (grid: any): ColumnSetting[] => {
  if (!grid) return [];
  const columnCount = grid.columnCount();
  const result: ColumnSetting[] = [];
  for (let i = 0; i < columnCount; i++) {
    const dataField = grid.columnOption(i, 'dataField');
    const caption = grid.columnOption(i, 'caption');
    const width = grid.columnOption(i, 'width');
    const visible = grid.columnOption(i, 'visible');
    const allowHiding = grid.columnOption(i, 'allowHiding') !== undefined ? grid.columnOption(i, 'allowHiding') : true;
    const order = grid.columnOption(i, 'visibleIndex') ?? i;
    result.push({ dataField, caption, width, visible, allowHiding, order });
  }
  return result;
};

// export const applySettingsToGrid = (grid: any, settingJson: string | any) => {
//   if (!grid) return;
//   let cols: any;
//   if (typeof settingJson === 'string') {
//     try {
//       cols = JSON.parse(settingJson);
//     } catch (error) {
//       console.error("Failed to parse settingJson:", error);
//       return;
//     }
//   } else {
//     cols = settingJson;
//   }
//   // Eğer veri { columnsConfig: [...] } şeklinde geliyorsa onu kullanın
//   if (cols && cols.columnsConfig) {
//     cols = cols.columnsConfig;
//   }
//   if (Array.isArray(cols)) {
//     cols.forEach((config: any) => {
//       grid.columnOption(config.dataField, "width", config.width);
//       grid.columnOption(config.dataField, "visible", config.visible);
//       grid.columnOption(config.dataField, "visibleIndex", config.order);
//       grid.columnOption(config.dataField, "allowHiding", config.allowHiding);
//     });
//   } else {
//     console.error("Parsed settings is not an array", cols);
//   }
// };

export const applySettingsToGrid = (grid: any, settingJson: string | any) => {
  if (!grid) {
    console.warn("Grid mevcut değil, uygulama yapılmadı");
    return;
  }
  if (settingJson === undefined || settingJson === null) {
    console.warn("settingJson mevcut değil, uygulama yapılmadı");
    return;
  }
  let cols: any;
  if (typeof settingJson === 'string') {
    try {
      cols = JSON.parse(settingJson);
    } catch (error) {
      console.error("Failed to parse settingJson:", error);
      return;
    }
  } else {
    cols = settingJson;
  }
  if (cols && cols.columnsConfig) {
    cols = cols.columnsConfig;
  }
  if (Array.isArray(cols)) {
    cols.forEach((config: any) => {
      grid.columnOption(config.dataField, "width", config.width);
      grid.columnOption(config.dataField, "visible", config.visible);
      grid.columnOption(config.dataField, "visibleIndex", config.order);
      grid.columnOption(config.dataField, "allowHiding", config.allowHiding);
    });
  } else {
    console.error("Parsed settings is not an array", cols);
  }
};

export const fetchSettingsFromApi = async (settingPage: string, settingObject: string): Promise<SavedSetting[]> => {
  try {
    const response = await pageSettingsGetListRequest(settingPage, settingObject);
    // API yanıtınız { resCode, resMessage, recordCount, dataSet } şeklinde olduğundan:
    if (response.resCode === 200 && response.dataSet) {
      return response.dataSet;
    }
    return [];
  } catch (error) {
    notify("Ayarlar çekilirken hata oluştu", "error", 3000);
    return [];
  }
};

export const fetchDefaultSettings = async (settingPage: string, settingObject: string): Promise<ColumnSetting[]> => {
  try {
    const response = await pageSettingsGetDefaultListRequest(settingPage, settingObject);
    if (response.dataSet && response.dataSet.length > 0) {
      const defaultSetting = response.dataSet.find((s: any) => s.isDefault === 1) || response.dataSet[0];
      if (!defaultSetting.settingJson) {
        console.error("Default setting JSON is missing:", defaultSetting);
        return [];
      }
      const defaultColumns: ColumnSetting[] = JSON.parse(defaultSetting.settingJson);
      return defaultColumns;
    }
    return [];
  } catch (error) {
    console.error("Error fetching default settings:", error);
    notify("Error fetching default settings", "error", 3000);
    return [];
  }
};

export const saveGridSettings = async (params: ISettingRequestParams): Promise<any> => {
  try {
    const response = await pageSettingsPostRequest(params);
    return response;
  } catch (error) {
    console.error("Error saving settings:", error);
    notify("Error saving settings", "error", 2500);
    throw error;
  }
};

export const getColumnProps = (
    columnSettings: ColumnSetting[],
    dataField: string
  ) => {
    const settings = columnSettings.find((cs) => cs.dataField === dataField);
    return {
      allowHiding: true,
      visible: settings?.visible ?? true,
      width: settings?.width,
    };
  };



